export default __webpack_public_path__ + "static/media/pic9.21851ebc.jpg";